export enum ETspMethodFormName {
  BaseAccountName = "BaseAccountName",
  BaseBasic = "BaseBasic",
  BaseToken = "BaseToken",
  BaseUsernameToken = "BaseUsernameToken",
  GeotabBasic = "GeotabBasic",
  TrimbleBasic = "TrimbleBasic",
  WebfleetBasic = "WebfleetBasic",
}
